import React, { useState } from 'react';
import { FormGroup, Label,CustomInput, Input, Row, Col, Tooltip } from "reactstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";

import './songRow.css'

const RowSelect = ({ values }) => {
  const { song, index, manageSongData, manageSongDataFile, blockedValeues } = values;
  const key = song.key;
  const validExtensions = ["aac", "m4a", "mp4", "m4b", "3gp", "aif", "aiff", "aifc", "flac", "mp3", "opus", "ogg", "wav"];

  const { t } = useTranslation();

  const presetOps = [
    { value: 'm', label: t("mastering.songRow.option.preset.acoustic") },
    { value: 'i', label: t("mastering.songRow.option.preset.allGenres") },
    { value: 'n', label: t("mastering.songRow.option.preset.classical") },
    { value: 'b', label: t("mastering.songRow.option.preset.clubHouseTechno") },
    { value: 'h', label: t("mastering.songRow.option.preset.edmMusic") },
    { value: 'f', label: t("mastering.songRow.option.preset.electronic") },
    { value: 'g', label: t("mastering.songRow.option.preset.electronicRaw") },
    { value: 'c', label: t("mastering.songRow.option.preset.hipHop") },
    { value: 'd', label: t("mastering.songRow.option.preset.hipHopBass") },
    { value: 'a', label: t("mastering.songRow.option.preset.popMusic") },
    { value: 'k', label: t("mastering.songRow.option.preset.popRnB") },
    { value: 'j', label: t("mastering.songRow.option.preset.rockMetal") },
    { value: 'e', label: t("mastering.songRow.option.preset.trap") },
    { value: 'l', label: t("mastering.songRow.option.preset.vocalFocused") }
  ];

  return (
    <div className="artistWrap" style={{flexDirection: "column"}}>
      <div className="artistWrap" style={{margin: "0"}}>
        <Col xs="2">
          <Input
            type="text"
            name={`song_tag_${key}`}
            value={song.tag}
            onChange={(e) => {
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
              manageSongData(index, 'tag', e.target.value);
            }}
            placeholder={t("mastering.songRow.placeholder.name")}
          />
        </Col>

        <Col xs="2">
          <Input
            type="text"
            name={`song_genre_${key}`}
            value={song.genre}
            onChange={(e) => {
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
              manageSongData(index, 'genre', e.target.value);
            }}
            placeholder={t("mastering.songRow.placeholder.genre")}
          />
        </Col>
        
        <Col xs="2">
          <Select
            name="preset"
            closeMenuOnSelect={true}
            options={presetOps}
            value={song.preset}
            onChange={(e) => {
              manageSongData(index, 'preset', e);  
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
            }}
            placeholder={t("mastering.songRow.placeholder.preset")}
            className="artistType"
          />
        </Col>
        <Col xs="2">
          <Input
            type="range"
            name={`song_intensity_${key}`}
            defaultValue={song.intensity}
            onChange={(e) => {
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
              manageSongData(index, 'intensity', e.target.value);
            }}
            min="1"
            max="100"
            step="1"
          />
          <output><b>{song.intensity} %</b></output>
        </Col>
        <Col xs="2">
          <Input
            type="range"
            name={`song_loudness_${key}`}
            defaultValue={song.loudness}
            onChange={(e) => {
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
              manageSongData(index, 'loudness', e.target.value);
            }}
            min="-22"
            max="-6"
            step="1"
          />
          <output><b>{song.loudness} dB</b></output>
        </Col>
        <Col xs="2">
          <CustomInput
            type="file"
            name={`song_${key}`}
            id={`song_${key}`}
            accept=".aac,.m4a,.mp4,.m4b,.3gp,.aif,.aiff,.aifc,.flac,.mp3,.opus,.ogg,.wav"
            onChange={(e) => {
              if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
                return;
              }
              else {
                document.getElementById(`err_song_file_valid_${key}`).style.display='none';
                const file = e.target.files[0];
                const name = file.name;
                const lastDot = name.lastIndexOf('.');
                const ext = name.substring(lastDot + 1);
                var extValid = (validExtensions.indexOf(ext) > -1);
                if(extValid)
                {
                  manageSongDataFile(index, 'song_file', e.target.files[0], key);
                }
                else
                {
                  document.getElementById(`err_song_file_valid_${key}`).style.display='block';
                }
              }
            }}
          />
          <div className="artistUpload" id={`uploadProgress_${key}`}>
          </div>
          <div className="uploadProgresDiv">
            <span id={`uploadProgress_text_${key}`}></span>
          </div>
        </Col>
      </div>
      <div style={{width: '100%', display: 'flex'}}>
        <Col xs="2"></Col>
        <Col xs="2"></Col>
        <Col xs="2"></Col>
        <Col xs="2"></Col>
        <Col xs="2"></Col>
        <Col xs="2"></Col>
      </div>
      <div style={{width: '100%', display: 'flex'}}>
        <Col xs="2">
          <div className="fv-help-block" style={{ display: 'none'}} id={`err_song_tag_${key}`}>{t("mastering.songRow.message.errorSongNameRequired")}</div>
          <div className="fv-help-block" style={{ display: 'none'}} id={`err_song_tag_length_${key}`}>{t("mastering.songRow.message.errorSongNameLength")}</div>
        </Col>
        <Col xs="2">
          <div className="fv-help-block" style={{ display: 'none'}} id={`err_song_genre_${key}`}>{t("mastering.songRow.message.errorGenreRequired")}</div>
          <div className="fv-help-block" style={{ display: 'none'}} id={`err_song_genre_length_${key}`}>{t("mastering.songRow.message.errorGenreLength")}</div>
        </Col>
        <Col xs="2">
          <div className="fv-help-block" style={{ display: 'none'}} id={"err_song_preset_" + key}>{t("mastering.songRow.message.errorPresetRequired")}</div>
        </Col>
        <Col xs="2">
        </Col>
        <Col xs="2">
        </Col>
        <Col xs="2">
          <div className="fv-help-block" style={{ display: 'none'}}  id={`err_song_file_${key}`}>{t("mastering.songRow.message.errorAudioFileRequired")}</div>
          <div className="fv-help-block" style={{ display: 'none'}}  id={`err_song_file_valid_${key}`}>{t("mastering.songRow.message.errorAudioFileValid")}</div>
        </Col>
      </div>
    </div>
  )
}


const RowLabel = () => {
  const { t } = useTranslation();
  const [intensityTooltipOpen, setIntensityTooltipOpen] = useState(false);
  const [loudnessTooltipOpen, setLoudnessTooltipOpen] = useState(false);
  const [audioFileTooltipOpen, setAudioFileTooltipOpen] = useState(false);
  
  const toggleIntensityTooltip = () => setIntensityTooltipOpen(!intensityTooltipOpen);
  const toggleLoudnessTooltip = () => setLoudnessTooltipOpen(!loudnessTooltipOpen);
  const toggleAudioFileTooltip = () => setAudioFileTooltipOpen(!audioFileTooltipOpen);

  return (
    <Row className="artistWrap labelRow">
      <Col xs="2">
        {t("mastering.songRow.label.name")}
      </Col>
      <Col xs="2">
        {t("mastering.songRow.label.genre")}
      </Col>
      <Col xs="2">
        {t("mastering.songRow.label.preset")}
      </Col>
      <Col xs="2">
        {t("mastering.songRow.label.intensity")}
        <i className="ml-1 tooltip-icon mdi mdi-18px mdi-help-circle" id="intensityTooltipIcon"></i>
        <Tooltip placement="top" isOpen={intensityTooltipOpen} target="intensityTooltipIcon" toggle={toggleIntensityTooltip}>
          {t("mastering.songRow.message.intensityTooltip")}
        </Tooltip>
      </Col>
      <Col xs="2">
        {t("mastering.songRow.label.loudness")}
        <i className="ml-1 tooltip-icon mdi mdi-18px mdi-help-circle" id="loudnessTooltipIcon"></i>
        <Tooltip placement="top" isOpen={loudnessTooltipOpen} target="loudnessTooltipIcon" toggle={toggleLoudnessTooltip}>
          {t("mastering.songRow.message.loudnessTooltip")}
        </Tooltip>
      </Col>
      <Col xs="2">
        {t("mastering.songRow.label.audioFile")}
        <i className="ml-1 tooltip-icon mdi mdi-18px mdi-help-circle" id="audioFileTooltipIcon"></i>
        <Tooltip placement="top" isOpen={audioFileTooltipOpen} target="audioFileTooltipIcon" toggle={toggleAudioFileTooltip}>
          {t("mastering.songRow.message.audioFileTooltip")}
        </Tooltip>
      </Col>
    </Row>
  )
}


const SongRow = ({ values, disabled = false, dataView = null, blockedValeues = null }) => {
  const { listOfSongs, manageSongData, manageSongDataFile, listOfSongsSET } = values;
  const { t } = useTranslation();
  return (
    <>
      <FormGroup style={{ paddingBottom: 30 }}>
        <Label><b>{t("mastering.songRow.label.songs")}</b></Label>
        <Row>
          <RowLabel />
          {
            listOfSongs.map((song, index) => {
              const itemVal = { index, song, manageSongData, manageSongDataFile, listOfSongs, listOfSongsSET, blockedValeues }
              return <RowSelect values={itemVal} key={song.key} />
            })
          }
        </Row>
      </FormGroup>
    </>
  );
};

export default SongRow;
